export const clearEcommerceDataLayer = () => {
    window.dataLayer.push({ 'ecommerce': null });
};

export const addViewItemListDataLayer = (searchResults) => {
    if (searchResults.data.length > 0) {
        clearEcommerceDataLayer();
        window.dataLayer.push({
            'ecommerce': {
                'items': searchResults.data.map((item, index) => {
                    let room_price = null;
                    if (item.hourly_rate !== null) {
                        room_price = item.hourly_rate;
                    } else if (item.daily_rate !== null) {
                        room_price = item.daily_rate;
                    } else if (item.monthly_rate !== null) {
                        room_price = item.monthly_rate;
                    }
                    return ({
                        'item_id': item.asset_id,
                        'item_name': item.title,
                        'affiliation': item.venue_id,
                        'currency': item.currency,
                        'price': room_price,
                        'item_brand': item.venue_name,
                        'item_category': item.vertical,
                        index
                    });
                })
            },
            'event': 'view_item_list'
        });
    }
};



// WEBPACK FOOTER //
// ./src/pages/Search/dataLayerEvents/index.js